// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Styles for slot catégories */
.schedule-container {
  min-width: 0;
  overflow-x: auto;
}

.schedule-container .absence-calendar .timeline-change,
.calendar-navigation {
  display: flex;
  align-items: center;
  gap: 0.625rem;
  margin-bottom: 1.25rem;
}

.schedule-container .absence-calendar .timeline-change button,
.calendar-navigation button,
.calendar-message button {
  min-height: 2.75rem;
  padding: 0.55rem 1rem;
  border: 1px solid #cbd3dc;
  border-radius: 0.65rem;
  background: #fff;
  color: var(--secondary-color);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 3px rgb(27 41 58 / 8%);
  transition: background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease;
}

.schedule-container .absence-calendar .timeline-change button:hover,
.calendar-navigation button:hover,
.calendar-message button:hover {
  background: #f7f8fa;
  border-color: var(--secondary-color);
  box-shadow: 0 2px 7px rgb(27 41 58 / 12%);
}

.schedule-container .absence-calendar .timeline-change button:focus-visible,
.calendar-navigation button:focus-visible,
.calendar-message button:focus-visible {
  outline: 3px solid var(--primary-color);
  outline-offset: 2px;
}

.schedule-container .absence-calendar .timeline-change button:nth-child(2),
.calendar-navigation__month {
  min-width: 10rem;
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.calendar-navigation__arrow {
  width: 2.75rem;
  padding: 0 !important;
  font-size: 1.75rem !important;
  line-height: 1;
}

.empty-calendar {
  min-width: 0;
}

.calendar-message {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border: 1px solid #d8e0e8;
  border-radius: 0.65rem;
  background: #f7f8fa;
}

.calendar-message--error {
  border-color: #f2b6c3;
  background: #fff5f7;
}

.calendar-message button {
  min-height: 2.25rem;
  border-color: var(--primary-color);
  color: var(--primary-color);
}

.empty-calendar__grid {
  display: grid;
  grid-template-columns: repeat(7, minmax(0, 1fr));
  overflow: hidden;
  border: 1px solid #d8e0e8;
  border-radius: 0.75rem;
  background: #fff;
}

.empty-calendar__weekday {
  padding: 0.7rem 0.3rem;
  background: #f7f8fa;
  color: var(--secondary-color);
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
}

.empty-calendar__day {
  min-height: 5.25rem;
  padding: 0.65rem;
  border-top: 1px solid #e7ebef;
  border-right: 1px solid #e7ebef;
}

.empty-calendar__day:nth-child(7n) {
  border-right: 0;
}

.empty-calendar__day--outside {
  background: #fafbfc;
}

.empty-calendar__day time {
  display: inline-grid;
  width: 1.9rem;
  height: 1.9rem;
  place-items: center;
}

.empty-calendar__day--today time {
  border-radius: 50%;
  background: var(--primary-color);
  color: #fff;
  font-weight: 700;
}

@media (max-width: 640px) {
  .empty-calendar__day {
    min-height: 3.5rem;
    padding: 0.3rem;
  }

  .calendar-navigation {
    justify-content: center;
  }
}

.item-vacation {
  background-color: #B5EAD7 !important;
  border: none !important;
}

.item-present {
  background-color: #C7CEEA !important;
  border: none !important;
}

.item-remote {
  background-color: #FFDAC1 !important;
  border: none !important;
}

.item-training {
  background-color: #FF9AA2 !important;
  border: none !important;
}

.item-sick {
  background-color: #FFF5BA !important;
  border: none !important;
}

.item-leave {
  background-color: #E2F0CB !important;
  border: none !important;
}

/* Style for disabled days*/
.item-disabled {
  background-color: #ece9d8 !important;
  /* opacity: 0.8; */
  pointer-events: none;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  height: 100% !important;
  top: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CalendarPage/style.css"],"names":[],"mappings":";AACA,+BAA+B;AAC/B;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,uFAAuF;AACzF;;AAEA;;;EAGE,mBAAmB;EACnB,oCAAoC;EACpC,yCAAyC;AAC3C;;AAEA;;;EAGE,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;EACE,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":["\n/* Styles for slot catégories */\n.schedule-container {\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.schedule-container .absence-calendar .timeline-change,\n.calendar-navigation {\n  display: flex;\n  align-items: center;\n  gap: 0.625rem;\n  margin-bottom: 1.25rem;\n}\n\n.schedule-container .absence-calendar .timeline-change button,\n.calendar-navigation button,\n.calendar-message button {\n  min-height: 2.75rem;\n  padding: 0.55rem 1rem;\n  border: 1px solid #cbd3dc;\n  border-radius: 0.65rem;\n  background: #fff;\n  color: var(--secondary-color);\n  font: inherit;\n  font-weight: 600;\n  cursor: pointer;\n  box-shadow: 0 1px 3px rgb(27 41 58 / 8%);\n  transition: background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease;\n}\n\n.schedule-container .absence-calendar .timeline-change button:hover,\n.calendar-navigation button:hover,\n.calendar-message button:hover {\n  background: #f7f8fa;\n  border-color: var(--secondary-color);\n  box-shadow: 0 2px 7px rgb(27 41 58 / 12%);\n}\n\n.schedule-container .absence-calendar .timeline-change button:focus-visible,\n.calendar-navigation button:focus-visible,\n.calendar-message button:focus-visible {\n  outline: 3px solid var(--primary-color);\n  outline-offset: 2px;\n}\n\n.schedule-container .absence-calendar .timeline-change button:nth-child(2),\n.calendar-navigation__month {\n  min-width: 10rem;\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.calendar-navigation__arrow {\n  width: 2.75rem;\n  padding: 0 !important;\n  font-size: 1.75rem !important;\n  line-height: 1;\n}\n\n.empty-calendar {\n  min-width: 0;\n}\n\n.calendar-message {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding: 0.85rem 1rem;\n  border: 1px solid #d8e0e8;\n  border-radius: 0.65rem;\n  background: #f7f8fa;\n}\n\n.calendar-message--error {\n  border-color: #f2b6c3;\n  background: #fff5f7;\n}\n\n.calendar-message button {\n  min-height: 2.25rem;\n  border-color: var(--primary-color);\n  color: var(--primary-color);\n}\n\n.empty-calendar__grid {\n  display: grid;\n  grid-template-columns: repeat(7, minmax(0, 1fr));\n  overflow: hidden;\n  border: 1px solid #d8e0e8;\n  border-radius: 0.75rem;\n  background: #fff;\n}\n\n.empty-calendar__weekday {\n  padding: 0.7rem 0.3rem;\n  background: #f7f8fa;\n  color: var(--secondary-color);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.empty-calendar__day {\n  min-height: 5.25rem;\n  padding: 0.65rem;\n  border-top: 1px solid #e7ebef;\n  border-right: 1px solid #e7ebef;\n}\n\n.empty-calendar__day:nth-child(7n) {\n  border-right: 0;\n}\n\n.empty-calendar__day--outside {\n  background: #fafbfc;\n}\n\n.empty-calendar__day time {\n  display: inline-grid;\n  width: 1.9rem;\n  height: 1.9rem;\n  place-items: center;\n}\n\n.empty-calendar__day--today time {\n  border-radius: 50%;\n  background: var(--primary-color);\n  color: #fff;\n  font-weight: 700;\n}\n\n@media (max-width: 640px) {\n  .empty-calendar__day {\n    min-height: 3.5rem;\n    padding: 0.3rem;\n  }\n\n  .calendar-navigation {\n    justify-content: center;\n  }\n}\n\n.item-vacation {\n  background-color: #B5EAD7 !important;\n  border: none !important;\n}\n\n.item-present {\n  background-color: #C7CEEA !important;\n  border: none !important;\n}\n\n.item-remote {\n  background-color: #FFDAC1 !important;\n  border: none !important;\n}\n\n.item-training {\n  background-color: #FF9AA2 !important;\n  border: none !important;\n}\n\n.item-sick {\n  background-color: #FFF5BA !important;\n  border: none !important;\n}\n\n.item-leave {\n  background-color: #E2F0CB !important;\n  border: none !important;\n}\n\n/* Style for disabled days*/\n.item-disabled {\n  background-color: #ece9d8 !important;\n  /* opacity: 0.8; */\n  pointer-events: none;\n  border: none !important;\n  outline: none !important;\n  box-shadow: none !important;\n  height: 100% !important;\n  top: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
